<template> 
<div class="m-1">
    <div class="mb-1">
        <navigation-bar
        v-if="screen_width>Skin.break_point"
            v-bind:skin="Skin"
            v-bind:translation="translation"
            v-bind:language="language"
            v-bind:navigation="sport ? [
            { name: sport.toUpperCase(),link:''},
            { name:translate('competitions'),link:'' },
            { name: country.name.toUpperCase(),link:''},
            {name: league.toUpperCase(),link:''},] : []"
        ></navigation-bar>
    </div>
    <div v-if="game" :style="Skin.live_event.fondo_data">
        <div :style="Skin.live_event.fondo_teams" style="position: relative;">
            <img style="position:absolute;top:0;right:0;height:100%;z-index:0" :src="'https://resources.jbets.online/frontJM/games_backgrounds/'+game.sport_alias+'.png'" onerror="this.src=''"/>
            <div class="text-start p-2 pb-0 py-2 d-flex" style="z-index: 2;position: relative;height: 20%;">
                <div v-if="screen_width>Skin.break_point" class="p-1 px-2 mb-1" style="width:20%;font-size:medium;background-color: rgb(0, 0, 0, 0.5);">{{ league }}</div>
                <div class="p-1 px-2 mb-1" :style="screen_width>Skin.break_point?'width:80%;':'width:100%;'" style="background-color: rgb(0, 0, 0, 0.5);">
                    <span v-for="(set, index) in [9,8,7,6,5,4,3,2,1]" :key="index" class="float-end mx-2">{{ game.stats["score_set"+set]?set:'' }}</span>
                </div>
            </div>
            <div class="p-2 pb-0 py-0" style="z-index: 2;position: relative;height: 70%;">
                <div class="p-1 px-2 mb-1" style="width:100%;background-color: rgb(0, 0, 0, 0.5);">
                    <img v-if="game.team1_name" :src="'https://statistics.betconstruct.com/images/e/m/'+Math.floor(game.team1_id / 2000)+'/'+game.team1_id+'.webp'" onerror="this.src='https://sport.megafaraon.com/images/icons/defaultSportLogos/1.png'" alt="team" width="18">
                    <!-- <shirt v-bind:color="'#'+(game.info.shirt1_color == '000000' ? 'ccc' : game.info.shirt1_color)"/> -->
                    <span class="mx-1" :style="Skin.prematch_event.teams_text">{{ game.team1_name }}</span>
                    <span v-for="(set, index) in [9,8,7,6,5,4,3,2,1]" :key="index" class="float-end mx-2">{{ game.stats["score_set"+set]?.team1_value }}</span>
                    <span class="float-end mx-4" :style="Skin.prematch_event.teams_text">{{ game.info.score1 }}</span>
                </div>
                <div class="p-1 px-2 mb-1" style="width:100%;background-color: rgb(0, 0, 0, 0.5);">
                    <img v-if="game.team2_name" :src="'https://statistics.betconstruct.com/images/e/m/'+Math.floor(game.team2_id / 2000)+'/'+game.team2_id+'.webp'" onerror="this.src='https://sport.megafaraon.com/images/icons/defaultSportLogos/1.png'" alt="team" width="18">
                    <!-- <span><shirt2 v-bind:color="'#'+(game.info.shirt2_color == '000000' ? 'f00' : game.info.shirt2_color)"/></span> -->
                    <span class="mx-1" :style="Skin.prematch_event.teams_text">{{ game.team2_name }}</span>
                    <span v-for="(set, index) in [9,8,7,6,5,4,3,2,1]" :key="index" class="float-end mx-2">{{ game.stats["score_set"+set]?.team2_value }}</span>
                    <span class="float-end mx-4" :style="Skin.prematch_event.teams_text">{{ game.info.score2 }}</span>
                </div>
                <div class="p-0 text-end">
                    <span class="p-2" style="width:100%;background-color: rgb(0, 0, 0, 0.5);font-size: small;"><span style="font-size:small">{{ game_state(game.info.current_game_state,sport) }}  {{ current_time(game.info.current_game_time,game.info.current_game_state,sport) }}{{ game.info.add_minutes ? (game.info.add_minutes != 0 ? "+"+game.info.add_minutes : "") : "" }}</span></span>
                </div>
            </div>
            <div class="p-2" style="z-index: 2;position: relative;height: 20%;">
                <span @click="collapseOdds" style="color:white;font-size: large;cursor: pointer;" class="me-2"><i class="fas fa-angle-double-up"></i></span>
                <span v-if="screen_width>Skin.break_point" @click="changeColumns" style="color:white;font-size: large;cursor: pointer;" class="mx-2"><i class="fas fa-columns"></i></span>
            </div>
        </div>
        <div>
            <allOdds
                v-bind:Skin="Skin"
                v-bind:language="language"
                v-bind:translation="translation"
                v-bind:game="game"
                v-bind:league="league"
                ref="allOdds"
            >
            </allOdds>
        </div>
    </div>
    <div v-else :style="Skin.live_event.fondo_not_available" style="height:93vh" class="text-center py-5">
        <p>{{translate("event_unavailable")}}</p>
    </div>
</div>

</template>

<script>
const flags = require('../../../../assets/countries.json');
import navigationBar from '../navigation/navigation_bar.vue';
import allOdds from './All_odds.vue';
import shirt from './shirt.vue';
import shirt2 from './shirt2.vue';
export default {
    name: 'encuentro_data',
    components:{
        allOdds,
        navigationBar,
        shirt,
        shirt2,
    },
    props: ['Skin','translation','language'],
    data(){
        return {
            screen_width:0,
            collapsedOdds:false
        }
    },
    methods:{
        collapseOdds(){
            this.$refs.allOdds.collapse_odds(!this.collapsedOdds);
            this.collapsedOdds = !this.collapsedOdds;
        },
        changeColumns(){
            this.$refs.allOdds.change_qtyColumns();
        },
        image_bg(screen,sport){
            switch (sport) {
                case 'Fútbol':
                    return screen > 460 ? 'futbol-bg':'futbol-bg-sm';
                case 'Baloncesto':
                    return screen > 460 ? 'basketball-bg':'basketball-bg-sm';
                default:
                    break;
            }
        },
        current_time(time,state,sport){
            switch (sport) {
                case 'Fútbol':
                    if(state == "Half Time"){
                        return '';
                    }
                    else if(state == "finished"){
                        return "";
                    }
                    else if(state == "notstarted"){
                        return "";
                    }
                    else if(state == "timeout"){
                        return "";
                    }
                    break;
                case 'Baloncesto':
                    if(state == "timeout"){
                        return ""
                    }
                    else if(state == "notstarted"){
                        return ""
                    }
                    break
                default:

                break; 
            }
            return time;
        },
        game_state(state,sport){
            switch (sport) {
                case 'Fútbol':
                case 'Football':
                case 'Soccer':
                    if(state == "set1"){
                        return this.translate('set1_soccer');
                    }
                    else if(state == "set2"){
                        return this.translate('set2_soccer');
                    }
                    else if(state == "set3"){
                        return this.translate('set3_soccer');
                    }
                    else if(state == "set4"){
                        return this.translate('set4_soccer');
                    }
                    else if(state == "set5"){
                        return this.translate('set5_soccer');
                    }
                    else if(state == "Half Time"){
                        return this.translate('half_time_soccer');
                    }
                    else if(state == "notstarted"){
                        return this.translate('notstarted');
                    }
                    else if(state == "timeout"){
                        return this.translate('timeout_soccer');
                    }
                    break;
                case 'Baloncesto':
                case 'Basketball':
                    if(state == "set1"){
                        return this.translate('set1_basket');
                    }
                    else if(state == "set2"){
                        return this.translate('set2_basket');
                    }
                    else if(state == "set3"){
                        return this.translate('set3_basket');
                    }
                    else if(state == "set4"){
                        return this.translate('set4_basket');
                    } 
                    else if(state == "timeout"){
                        return this.translate('timeout_basket');
                    }
                    else if(state == "notstarted"){
                        return this.translate('notstarted');
                    }
                    break
                case 'Béisbol':
                case 'Baseball':
                    if(state == "set1"){
                        return "1er Inning"
                    }
                    else if(state == "set2"){
                        return "2do Inning"
                    }
                    else if(state == "set3"){
                        return "3er Inning"
                    }
                    else if(state == "set4"){
                        return "4to Inning"
                    } 
                    else if(state == "set5"){
                        return "5th Inning"
                    } 
                    else if(state == "set6"){
                        return "6th Inning"
                    } 
                    else if(state == "set7"){
                        return "7th Inning"
                    } 
                    else if(state == "set8"){
                        return "8th Inning"
                    } 
                    else if(state == "set9"){
                        return "9th Inning"
                    } 
                    else if(state == "set10"){
                        return "10th Inning"
                    } 
                    else if(state == "timeout"){
                        return "Timeout"
                    }
                    else if(state == "notstarted"){
                        return this.translate('notstarted')
                    }
                    break
                case 'Tenis':
                case 'Tennis':
                    return state;
                case 'Hockey Sobre Hielo':
                case 'Ice Hockey':
                    if(state == "set1"){
                        return this.translate('set1_soccer');
                    }
                    else if(state == "set2"){
                        return this.translate('set2_soccer');
                    }
                    else if(state == "set3"){
                        return this.translate('set3_hockey');
                    }
                    else if(state == "notstarted"){
                        return this.translate('notstarted');
                    }
                    else if(state == "timeout"){
                        return this.translate('timeout_soccer');
                    }
                default:
                    return state
                break;
            }
        },
        sizeControl(){
            this.screen_width=window.innerWidth;
        },
        translate(text) {
            if(text){
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else{
                    var new_text_serched = text.replace(/ /g, "_");
                if (this.$props.translation[new_text_serched]) {
                    return this.$props.translation[new_text_serched][this.$props.language];
                }
                }
                return text;
            }
        }
    },
    computed:{
        sport(){
            if(Object.keys(this.$store.getters['live/getLiveEvent']).length>0){
                let data = this.$store.getters['live/getLiveEvent'].data.data.sport;
                let sport = Object.keys(data)[0];
                return data[sport].name;
            }
            return "";
        },
        league(){
            let data = this.$store.getters['live/getLiveEvent'].data.data.sport;
            let sport = Object.keys(data)[0];
            let region_idx = Object.keys(data[sport].region)[0];
            let league_idx = Object.keys(data[sport].region[region_idx].competition)[0];
            return data[sport].region[region_idx].competition[league_idx].name;
        },
        country(){
            if(Object.keys(this.$store.getters['live/getLiveEvent']).length>0){
                let data = this.$store.getters['live/getLiveEvent'].data.data.sport;
                let sport = Object.keys(data)[0];
                let region_idx = Object.keys(data[sport].region)[0];
                let code = "";
                flags.countries.forEach(country => {
                    if(country.name_en == data[sport].region[region_idx].alias){
                        code = country.code.toLowerCase();
                    }
                });
                code = code == "" ? "int" :code;
                return {code:code,name:data[sport].region[region_idx].alias};
            }
            return "";
        },
        game(){
            let self = this;
            let loaded = this.$store.getters['live/getLoadedLiveData'];
            if(Object.keys(this.$store.getters['live/getLiveEvent']).length > 0){
                if(this.$store.getters['live/getLiveEvent'].data){
                    var data = this.$store.getters['live/getLiveEvent'].data.data.sport || {};
                    if(Object.keys(data).length>0){
                        let sport = Object.keys(data)[0];
                        let region_idx = Object.keys(data[sport].region)[0];
                        let league_idx = Object.keys(data[sport].region[region_idx].competition)[0];
                        let game_idx = Object.keys(data[sport].region[region_idx].competition[league_idx].game)[0];
                        if(data[sport].region[region_idx].competition[league_idx].game[game_idx]){
                            if(data[sport].region[region_idx].competition[league_idx].game[game_idx].info){
                                return data[sport].region[region_idx].competition[league_idx].game[game_idx];
                            } 
                        }
                    }
                    if(loaded){const timeout1 = setTimeout(function(){self.$store.dispatch('live/setTargetEvent',1);}, 3000);}
                    return false;
                }
                if(loaded){const timeout1 = setTimeout(function(){self.$store.dispatch('live/setTargetEvent',1);}, 3000);}
                return false;
            }
            if(loaded){const timeout1 = setTimeout(function(){self.$store.dispatch('live/setTargetEvent',1);}, 3000);}
            return false;
        },
    },
    created() {
        this.sizeControl();
    },
    mounted(){
        window.addEventListener('resize', ()=>{this.sizeControl();});
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.long_text {
  display: -webkit-box;
  max-width: 100px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

</style>
